"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.patch = exports.put = exports.post = exports.get = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
 * File: Http.js
 * Project: patient-portal-api-requests
 *
 * Created by Nate Weber on 08/13/2020, moved by Jed Dumire 09/17/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: This handles configuration and making
 * HTTP requests.
 */
// Configuration
_axios["default"].defaults.baseURL = "/api/patientportal/";
_axios["default"].defaults.headers.common["Content-Type"] = "application/json";
_axios["default"].defaults.headers.common["Accept"] = "application/json"; // Interceptors

_axios["default"].interceptors.request.use( // On success
function (config) {
  if (config.url.endsWith("login") === false) {
    config.headers.authorization = 'Bearer ' + window.sessionStorage.getItem("authToken");
  }

  return config;
}, // On error
function (error) {
  return Promise.reject(error);
});

_axios["default"].interceptors.response.use( // Response successful
function (response) {
  var token = response.headers.authorization;

  if (token && token.toLowerCase().startsWith('bearer ')) {
    var parts = token.split(" ");

    if (parts.length > 1) {
      window.sessionStorage.setItem("authToken", parts[1]);
    }
  }

  return response;
}, // Response error
function (error) {
  return Promise.reject(error);
}); // Public API


var get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _axios["default"].get(url, {
    params: params
  });
};

exports.get = get;

var post = function post(url, data) {
  return _axios["default"].post(url, data);
};

exports.post = post;

var put = function put(url, data) {
  return _axios["default"].put(url, data);
};

exports.put = put;

var patch = function patch(url, data) {
  return _axios["default"].patch(url, data);
};

exports.patch = patch;

var remove = function remove(url) {
  return _axios["default"]["delete"](url);
};

exports.remove = remove;